import { render, staticRenderFns } from "./CookieMessage.vue?vue&type=template&id=6c0a4556&"
import script from "./CookieMessage.vue?vue&type=script&lang=ts&"
export * from "./CookieMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports